import { VoiceRecorder } from '@independo/capacitor-voice-recorder'
import { App } from '@capacitor/app'

export type PermissionState = 'granted' | 'denied' | 'prompt'

export async function checkMicPermission(): Promise<PermissionState> {
  const r = await VoiceRecorder.hasAudioRecordingPermission()
  return r.value ? 'granted' : 'prompt'
}

export async function requestMicPermission(): Promise<PermissionState> {
  const r = await VoiceRecorder.requestAudioRecordingPermission()
  return r.value ? 'granted' : 'denied'
}

export function openAppSettings(): Promise<void> {
  return App.openUrl({ url: 'app-settings:' }) as unknown as Promise<void>
}
